import {useState, useEffect} from "react";
import SearchIcon from "@mui/icons-material/Search";
import {Table} from "react-bootstrap";
import axios from "axios";
import core from "../../../core";
import {Pagination, Stack} from "@mui/material";

const Payments = () => {
    const [payments, setPayments] = useState([]);
    const [searchFieldValue, setSearchFieldValue] = useState("");
    const [keyword, setKeyword] = useState("");
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);
    const limit = 10;

    useEffect(() => {
        setLoading(true);
        axios(`/api/admin/payments?keyword=${keyword}&page=${page}&limit=${limit}`)
            .then((res) => {
                setLoading(false);
                setPayments(res.data.data);
                setTotal(res.data.total);
            })
            .catch((err) => {
                console.error("Error fetching payments:", err);
                setLoading(false);
            });
    }, [keyword, page]);

    return(
        <>
            <h3 style={{marginBottom: "35px"}}>Transactions</h3>
            <div style={{width: "100%"}}>
                <div className={"data-table-header"}>
                    <div className={"search-field-container"}>
                        <input type={"text"}
                               onKeyUp={(e) => {
                                   if (e.keyCode === 13) {
                                       setKeyword(searchFieldValue);
                                   }
                               }}
                               onChange={(e) => setSearchFieldValue(e.target.value)}
                               placeholder={"Enter keyword"}
                               className={"search-field"}/>
                        <button><SearchIcon onClick={() => setKeyword(searchFieldValue)} style={{color: "white"}}/>
                        </button>
                    </div>
                </div>
                <Table responsive style={{width: "100%"}} className={"data-table"}>
                    <thead>
                        <tr>
                            <th>Status</th>
                            <th>Transaction #</th>
                            <th>Payment Date</th>
                            <th>Amount</th>
                            <th>ID Number</th>
                            <th>User ID</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            loading == false ? payments.map((p, i) => {
                                return (
                                    <tr className={`${i % 2 === 1 ? 'odd-row' : 'even-row'} table-rows`}
                                        key={p.id}>
                                        <td>{p.transaction_status}</td>
                                        <td title={p.transaction_id}>{p.transaction_id.slice(0, 15)}</td>
                                        <td>{core.formatDate(p.transaction_date)}</td>
                                        <td>{p.amount}</td>
                                        <td>{p.payer_id_number}</td>
                                        <td>{p.payer_user_id}</td>
                                    </tr>
                                )
                            }) : <tr><td colSpan={6}>Loading...</td></tr>
                        }
                        {
                            (payments.length === 0 && !loading) && (
                                <tr>
                                    <td colSpan={9} style={{padding: "12px 0"}}>
                                        <p style={{width: "100%", textAlign: "center"}}>Records not found</p>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
                <div className={"pagination-container"}>
                    <p>Total: {total}</p>
                    <Stack spacing={2}>
                        <Pagination count={Math.ceil(total / limit)} size="large" page={page} onChange={(e, v) => setPage(v)}/>
                    </Stack>
                </div>
            </div>
        </>
    )
}

export default Payments